exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".link[data-v-505df776]{cursor:pointer;opacity:.8;stroke:#333;stroke-width:3}.arrow[data-v-505df776]{fill:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-505df776&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pointLink.vue
// module id = 59
// module chunks = 0